var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect, useState, useRef } from 'react';
import rollbar from 'shared-assets/src/errors/errors';
import { cssVariableDefaultStyles } from 'shared-assets/components/WindowDimensionsProvider';
import BrowserSupport from './BrowserSupport';
import { wherebyMobileSupport } from '../util/browser';
var WHEREBY_LOADING_TIMEOUT = 15000; // amount of time in milliseconds that we wait before reporting a rollbar error
var VideoService = function (_a) {
    var displayName = _a.displayName, room = _a.room, style = _a.style, title = _a.title, videoStatusCallback = _a.videoStatusCallback;
    var _b = useState(true), showIframe = _b[0], setShowIframe = _b[1];
    /**
     * create a timer that will throw an warning in rollbar if the ready event doesnt get fired within {WHEREBY_LOADING_TIMEOUT}
     * "ready" event could not get fired because WhereBy changes there API (https://whereby.dev/embed/) - Listening to event
     */
    var timerRef = useRef();
    useEffect(function () {
        timerRef.current = setTimeout(function () {
            rollbar.warning('Authenticated Ui is taking longer than expected to load iframe');
        }, WHEREBY_LOADING_TIMEOUT);
        return function () { return clearTimeout(timerRef.current); };
    }, [timerRef]);
    var statusCallback = useCallback(function (statusType, detail) {
        videoStatusCallback(statusType, detail);
        switch (statusType) {
            case 'leave':
                setShowIframe(false);
                break;
            case 'ready':
                if (!!timerRef.current) {
                    // clear timer for long loading iframe
                    clearTimeout(timerRef.current);
                }
                setShowIframe(true);
                break;
            default:
                break;
        }
    }, [setShowIframe, timerRef, videoStatusCallback]);
    var messageCallback = useCallback(function (event) {
        // check that message is coming from whereby
        var whereByCheckUrl = new URL('', "https://kareo.whereby.com");
        if (!event.data || event.origin !== whereByCheckUrl.origin)
            return;
        var _a = event.data, type = _a.type, detail = _a.payload;
        try {
            statusCallback(type, detail);
        }
        catch (e) {
            rollbar.error(e);
        }
    }, [statusCallback]);
    useEffect(function () {
        if (window) {
            document.getElementsByTagName('body')[0].style.background = '#252a2b';
            window.addEventListener('message', messageCallback);
        }
        else {
            throw new Error('window not found to add event listener for messsage');
        }
        return function () {
            if (window) {
                window.removeEventListener('message', messageCallback);
            }
        };
    }, [messageCallback]);
    if (!room || !room.url)
        return null;
    var url = new URL(room.url);
    var isHost = url.searchParams.has('roomKey');
    var searchParams = new URLSearchParams({
        ageWarning: 'off',
        audio: 'on',
        background: 'off',
        chat: 'on',
        displayName: displayName,
        embed: '',
        iframeSource: 'kareo',
        leaveButton: 'on',
        recording: 'off',
        screenshare: 'on',
        video: 'on',
    });
    if (isHost) {
        searchParams.set('locking', 'on');
    }
    searchParams.forEach(function (value, key) {
        url.searchParams.set(key, value);
    });
    if (!wherebyMobileSupport()) {
        return React.createElement(BrowserSupport, null);
    }
    return !!room && !!room.url ? (React.createElement("iframe", { style: __assign(__assign({ position: 'fixed', border: 'none', 
            // we use display none so that the session loads given the url
            display: !!showIframe ? 'block' : 'none' }, cssVariableDefaultStyles), style), title: title, src: url.toString(), allow: "camera; microphone; fullscreen; speaker; display-capture" })) : null;
};
VideoService.defaultProps = {
    displayName: 'Participant',
    style: {},
    videoStatusCallback: function () { },
};
export default VideoService;
